import { render } from "./SkillsetView.vue?vue&type=template&id=c8fdb716"
import script from "./SkillsetView.vue?vue&type=script&lang=js"
export * from "./SkillsetView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__